"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var ContentLine_1 = require("../../../contentLine/ContentLine");
var Translation_1 = require("../../../../../../../common/components/presentation/Translation/Translation");
var emissionsStyles_1 = require("./emissionsStyles");
var Emissions = function (_a) {
    var coTwo = _a.coTwo, range = _a.range;
    var styles = emissionsStyles_1.default();
    var emission = coTwo || range;
    return emission ? (<core_1.Grid item={true}>
      <ContentLine_1.default className={styles.container} mainContent={<core_1.Typography variant="subtitle1">
            <Translation_1.default id={coTwo
        ? 'trans__checkout__vehicle_details__co2emissions_label'
        : 'trans__checkout__vehicle_details__wltp_range_label'}/>
          </core_1.Typography>} secondaryContent={<core_1.Typography variant="subtitle1">
            {emission}
            <Translation_1.default id={coTwo
        ? 'trans__checkout__vehicle_details__co2emissions_unit'
        : 'trans__checkout__vehicle_details__wltp_range_unit'}/>
          </core_1.Typography>} dataTest="summary:car_details:wltp"/>
    </core_1.Grid>) : null;
};
exports.default = Emissions;
